// Sell flow (Create a Listing / Import from URL) strings — merged into translations.js
export const sellFlow = {
  en: {
    "sell.cancel": "Cancel",
    "sell.mode.title": "Create a Listing",
    "sell.mode.subtitle": "Choose how you want to create your listing",
    "sell.mode.createTitle": "Create New Listing",
    "sell.mode.createDesc": "Upload photos and add details",
    "sell.mode.createBtn": "Start Creating",
    "sell.mode.importTitle": "Import from URL",
    "sell.mode.importDesc": "Paste a link from another website",
    "sell.mode.importBtn": "Import Listing",
    "sell.mode.aiNote": "Import feature uses AI to extract and rewrite listing details",
    "sell.step.photos": "Photos",
    "sell.step.details": "Details",
    "sell.step.review": "Review",
    "sell.step.importUrl": "Import URL",
    "sell.import.title": "Import Listing",
    "sell.import.urlLabel": "Listing URL",
    "sell.import.howItWorks": "How it works:",
    "sell.import.how1": "AI extracts title, price, description, and location",
    "sell.import.how2": "Description is professionally rewritten",
    "sell.import.how3": "You'll upload your own photos in the next step",
    "sell.import.how4": "Review and edit everything before posting",
    "sell.import.importing": "Importing with AI...",
    "sell.import.continue": "Import & Continue",
    "sell.import.manual": "Or create a listing manually →",
    "sell.import.enterUrl": "Please enter a URL",
    "sell.import.failed": "Failed to import listing",
    "sell.import.success": "Listing data imported!",
    "sell.photos.addTitle": "Add Photos",
    "sell.photos.uploadTitle": "Upload Photos",
    "sell.photos.counter": "{n}/{max} photos • First photo will be the cover",
    "sell.photos.max": "Maximum photos reached",
    "sell.photos.click": "Click to upload or drag and drop",
    "sell.photos.formats": "PNG, JPG up to 10MB each",
    "sell.photos.reorder": "Drag to reorder • First image is the cover",
    "sell.photos.reorderShort": "Drag to reorder • First is cover",
    "sell.photos.cover": "Cover",
    "sell.photos.uploaded": "{n} photo(s) uploaded",
    "sell.photos.add": "Add",
    "sell.photos.aiTitle": "AI Auto-Fill",
    "sell.photos.aiDesc": "Analyze photos to prefill details",
    "sell.photos.analyze": "Analyze",
    "sell.nav.back": "Back",
    "sell.nav.continue": "Continue",
    "sell.nav.review": "Review Listing",
    "sell.nav.backToPhotos": "Back to Photos",
    "sell.nav.publish": "Publish Listing",
    "sell.nav.publishing": "Publishing...",
    "sell.nav.cancelHome": "Cancel and return to homepage",
    "sell.nav.saveChanges": "Save Changes",
    "sell.nav.editDetails": "Edit Details",
    "sell.details.title": "Listing Details",
    "sell.details.aiPrefilled": "AI prefilled some fields",
    "sell.details.editTitle": "Edit Details",
    "sell.details.editSubtitle": "Update your listing information",
    "sell.field.title": "Title",
    "sell.field.titlePh": "What are you selling?",
    "sell.field.category": "Category",
    "sell.field.selectCategory": "Select category",
    "sell.field.subcategory": "Subcategory",
    "sell.field.selectSubcategory": "Select subcategory",
    "sell.field.transactionType": "Transaction Type",
    "sell.field.selectType": "Select type",
    "sell.field.price": "Price",
    "sell.field.priceType": "Price Type",
    "sell.price.fixed": "Fixed Price",
    "sell.price.negotiable": "Negotiable",
    "sell.price.free": "Free",
    "sell.field.location": "Location",
    "sell.field.worldwide": "This category allows listings from anywhere in the world",
    "sell.field.locationPh": "Search for a location...",
    "sell.field.locationPhWorld": "Search any location worldwide...",
    "sell.field.description": "Description",
    "sell.field.descriptionPh": "Describe your item in detail...",
    "sell.field.condition": "Condition",
    "sell.field.selectCondition": "Select condition",
    "sell.field.shipping": "Shipping Available",
    "sell.field.shippingDesc": "Can you ship this item?",
    "sell.field.propertyDetails": "Property Details",
    "sell.field.additionalDetails": "Additional Details",
    "sell.field.optionalHint": "(optional - helps buyers find your listing)",
    "sell.field.select": "Select {label}",
    "sell.validation.title": "Title is required",
    "sell.validation.category": "Category is required",
    "sell.validation.subcategory": "Subcategory is required",
    "sell.validation.transactionType": "Transaction type is required",
    "sell.validation.location": "Location is required",
    "sell.validation.price": "Price is required",
    "sell.review.title": "Review Your Listing",
    "sell.review.subtitle": "Make sure everything looks good",
    "sell.review.morePhotos": "+{n} photos",
    "sell.review.noPhotos": "No photos added",
    "sell.review.untitled": "Untitled",
    "sell.review.free": "Free",
    "sell.review.negotiable": "Negotiable",
    "sell.review.noLocation": "No location",
    "sell.review.category": "Category:",
    "sell.review.type": "Type:",
    "sell.review.condition": "Condition:",
    "sell.review.yes": "Yes",
    "sell.review.no": "No",
    "sell.review.shipping": "Shipping Available",
    "sell.review.forRent": "For Rent",
    "sell.review.forSale": "For Sale",
    "sell.error.publish": "Failed to publish your draft",
    "sell.error.link": "Failed to send the link",
    "sell.error.create": "Failed to create listing",
  },
  fr: {
    "sell.cancel": "Annuler",
    "sell.mode.title": "Déposer une annonce",
    "sell.mode.subtitle": "Choisissez comment créer votre annonce",
    "sell.mode.createTitle": "Créer une nouvelle annonce",
    "sell.mode.createDesc": "Ajoutez des photos et les détails",
    "sell.mode.createBtn": "Commencer",
    "sell.mode.importTitle": "Importer depuis une URL",
    "sell.mode.importDesc": "Collez un lien d'un autre site",
    "sell.mode.importBtn": "Importer l'annonce",
    "sell.mode.aiNote": "L'import utilise l'IA pour extraire et réécrire les détails de l'annonce",
    "sell.step.photos": "Photos",
    "sell.step.details": "Détails",
    "sell.step.review": "Vérification",
    "sell.step.importUrl": "URL",
    "sell.import.title": "Importer une annonce",
    "sell.import.urlLabel": "URL de l'annonce",
    "sell.import.howItWorks": "Comment ça marche :",
    "sell.import.how1": "L'IA extrait le titre, le prix, la description et la localisation",
    "sell.import.how2": "La description est réécrite de façon professionnelle",
    "sell.import.how3": "Vous ajouterez vos propres photos à l'étape suivante",
    "sell.import.how4": "Vérifiez et modifiez tout avant de publier",
    "sell.import.importing": "Import avec l'IA...",
    "sell.import.continue": "Importer et continuer",
    "sell.import.manual": "Ou créer une annonce manuellement →",
    "sell.import.enterUrl": "Veuillez saisir une URL",
    "sell.import.failed": "Échec de l'import de l'annonce",
    "sell.import.success": "Données de l'annonce importées !",
    "sell.photos.addTitle": "Ajouter des photos",
    "sell.photos.uploadTitle": "Ajouter des photos",
    "sell.photos.counter": "{n}/{max} photos • La première photo sera la couverture",
    "sell.photos.max": "Nombre maximum de photos atteint",
    "sell.photos.click": "Cliquez pour ajouter ou glissez-déposez",
    "sell.photos.formats": "PNG, JPG jusqu'à 10 Mo chacune",
    "sell.photos.reorder": "Glissez pour réorganiser • La première image est la couverture",
    "sell.photos.reorderShort": "Glissez pour réorganiser • La première est la couverture",
    "sell.photos.cover": "Couverture",
    "sell.photos.uploaded": "{n} photo(s) ajoutée(s)",
    "sell.photos.add": "Ajouter",
    "sell.photos.aiTitle": "Remplissage automatique IA",
    "sell.photos.aiDesc": "Analyser les photos pour préremplir les détails",
    "sell.photos.analyze": "Analyser",
    "sell.nav.back": "Retour",
    "sell.nav.continue": "Continuer",
    "sell.nav.review": "Vérifier l'annonce",
    "sell.nav.backToPhotos": "Retour aux photos",
    "sell.nav.publish": "Publier l'annonce",
    "sell.nav.publishing": "Publication...",
    "sell.nav.cancelHome": "Annuler et revenir à l'accueil",
    "sell.nav.saveChanges": "Enregistrer",
    "sell.nav.editDetails": "Modifier les détails",
    "sell.details.title": "Détails de l'annonce",
    "sell.details.aiPrefilled": "L'IA a prérempli certains champs",
    "sell.details.editTitle": "Modifier les détails",
    "sell.details.editSubtitle": "Mettez à jour les informations de votre annonce",
    "sell.field.title": "Titre",
    "sell.field.titlePh": "Que vendez-vous ?",
    "sell.field.category": "Catégorie",
    "sell.field.selectCategory": "Choisir une catégorie",
    "sell.field.subcategory": "Sous-catégorie",
    "sell.field.selectSubcategory": "Choisir une sous-catégorie",
    "sell.field.transactionType": "Type de transaction",
    "sell.field.selectType": "Choisir le type",
    "sell.field.price": "Prix",
    "sell.field.priceType": "Type de prix",
    "sell.price.fixed": "Prix fixe",
    "sell.price.negotiable": "Négociable",
    "sell.price.free": "Gratuit",
    "sell.field.location": "Localisation",
    "sell.field.worldwide": "Cette catégorie accepte des annonces du monde entier",
    "sell.field.locationPh": "Rechercher une localité...",
    "sell.field.locationPhWorld": "Rechercher un lieu dans le monde...",
    "sell.field.description": "Description",
    "sell.field.descriptionPh": "Décrivez votre article en détail...",
    "sell.field.condition": "État",
    "sell.field.selectCondition": "Choisir l'état",
    "sell.field.shipping": "Livraison possible",
    "sell.field.shippingDesc": "Pouvez-vous expédier cet article ?",
    "sell.field.propertyDetails": "Détails du bien",
    "sell.field.additionalDetails": "Détails supplémentaires",
    "sell.field.optionalHint": "(facultatif - aide les acheteurs à trouver votre annonce)",
    "sell.field.select": "Choisir : {label}",
    "sell.validation.title": "Le titre est obligatoire",
    "sell.validation.category": "La catégorie est obligatoire",
    "sell.validation.subcategory": "La sous-catégorie est obligatoire",
    "sell.validation.transactionType": "Le type de transaction est obligatoire",
    "sell.validation.location": "La localisation est obligatoire",
    "sell.validation.price": "Le prix est obligatoire",
    "sell.review.title": "Vérifiez votre annonce",
    "sell.review.subtitle": "Assurez-vous que tout est correct",
    "sell.review.morePhotos": "+{n} photos",
    "sell.review.noPhotos": "Aucune photo ajoutée",
    "sell.review.untitled": "Sans titre",
    "sell.review.free": "Gratuit",
    "sell.review.negotiable": "Négociable",
    "sell.review.noLocation": "Pas de localisation",
    "sell.review.category": "Catégorie :",
    "sell.review.type": "Type :",
    "sell.review.condition": "État :",
    "sell.review.yes": "Oui",
    "sell.review.no": "Non",
    "sell.review.shipping": "Livraison possible",
    "sell.review.forRent": "À louer",
    "sell.review.forSale": "À vendre",
    "sell.error.publish": "Impossible de publier votre brouillon",
    "sell.error.link": "Impossible d'envoyer le lien",
    "sell.error.create": "Impossible de créer l'annonce",
  },
  de: {
    "sell.cancel": "Abbrechen",
    "sell.mode.title": "Anzeige erstellen",
    "sell.mode.subtitle": "Wählen Sie, wie Sie Ihre Anzeige erstellen möchten",
    "sell.mode.createTitle": "Neue Anzeige erstellen",
    "sell.mode.createDesc": "Fotos hochladen und Details hinzufügen",
    "sell.mode.createBtn": "Jetzt starten",
    "sell.mode.importTitle": "Von URL importieren",
    "sell.mode.importDesc": "Link von einer anderen Website einfügen",
    "sell.mode.importBtn": "Anzeige importieren",
    "sell.mode.aiNote": "Der Import nutzt KI, um die Anzeigendetails zu extrahieren und neu zu formulieren",
    "sell.step.photos": "Fotos",
    "sell.step.details": "Details",
    "sell.step.review": "Prüfen",
    "sell.step.importUrl": "URL",
    "sell.import.title": "Anzeige importieren",
    "sell.import.urlLabel": "Anzeigen-URL",
    "sell.import.howItWorks": "So funktioniert es:",
    "sell.import.how1": "KI extrahiert Titel, Preis, Beschreibung und Standort",
    "sell.import.how2": "Die Beschreibung wird professionell neu formuliert",
    "sell.import.how3": "Im nächsten Schritt laden Sie Ihre eigenen Fotos hoch",
    "sell.import.how4": "Alles vor der Veröffentlichung prüfen und bearbeiten",
    "sell.import.importing": "Import mit KI...",
    "sell.import.continue": "Importieren & weiter",
    "sell.import.manual": "Oder Anzeige manuell erstellen →",
    "sell.import.enterUrl": "Bitte geben Sie eine URL ein",
    "sell.import.failed": "Import der Anzeige fehlgeschlagen",
    "sell.import.success": "Anzeigendaten importiert!",
    "sell.photos.addTitle": "Fotos hinzufügen",
    "sell.photos.uploadTitle": "Fotos hochladen",
    "sell.photos.counter": "{n}/{max} Fotos • Das erste Foto wird das Titelbild",
    "sell.photos.max": "Maximale Anzahl an Fotos erreicht",
    "sell.photos.click": "Klicken zum Hochladen oder Dateien hierher ziehen",
    "sell.photos.formats": "PNG, JPG bis zu 10 MB pro Datei",
    "sell.photos.reorder": "Zum Sortieren ziehen • Das erste Bild ist das Titelbild",
    "sell.photos.reorderShort": "Zum Sortieren ziehen • Erstes = Titelbild",
    "sell.photos.cover": "Titelbild",
    "sell.photos.uploaded": "{n} Foto(s) hochgeladen",
    "sell.photos.add": "Hinzufügen",
    "sell.photos.aiTitle": "KI-Autovervollständigung",
    "sell.photos.aiDesc": "Fotos analysieren, um Details vorauszufüllen",
    "sell.photos.analyze": "Analysieren",
    "sell.nav.back": "Zurück",
    "sell.nav.continue": "Weiter",
    "sell.nav.review": "Anzeige prüfen",
    "sell.nav.backToPhotos": "Zurück zu den Fotos",
    "sell.nav.publish": "Anzeige veröffentlichen",
    "sell.nav.publishing": "Wird veröffentlicht...",
    "sell.nav.cancelHome": "Abbrechen und zur Startseite",
    "sell.nav.saveChanges": "Änderungen speichern",
    "sell.nav.editDetails": "Details bearbeiten",
    "sell.details.title": "Anzeigendetails",
    "sell.details.aiPrefilled": "KI hat einige Felder vorausgefüllt",
    "sell.details.editTitle": "Details bearbeiten",
    "sell.details.editSubtitle": "Aktualisieren Sie die Informationen Ihrer Anzeige",
    "sell.field.title": "Titel",
    "sell.field.titlePh": "Was verkaufen Sie?",
    "sell.field.category": "Kategorie",
    "sell.field.selectCategory": "Kategorie wählen",
    "sell.field.subcategory": "Unterkategorie",
    "sell.field.selectSubcategory": "Unterkategorie wählen",
    "sell.field.transactionType": "Transaktionsart",
    "sell.field.selectType": "Art wählen",
    "sell.field.price": "Preis",
    "sell.field.priceType": "Preisart",
    "sell.price.fixed": "Festpreis",
    "sell.price.negotiable": "Verhandelbar",
    "sell.price.free": "Kostenlos",
    "sell.field.location": "Standort",
    "sell.field.worldwide": "Diese Kategorie erlaubt Anzeigen aus der ganzen Welt",
    "sell.field.locationPh": "Ort suchen...",
    "sell.field.locationPhWorld": "Beliebigen Ort weltweit suchen...",
    "sell.field.description": "Beschreibung",
    "sell.field.descriptionPh": "Beschreiben Sie Ihren Artikel ausführlich...",
    "sell.field.condition": "Zustand",
    "sell.field.selectCondition": "Zustand wählen",
    "sell.field.shipping": "Versand möglich",
    "sell.field.shippingDesc": "Können Sie diesen Artikel versenden?",
    "sell.field.propertyDetails": "Immobiliendetails",
    "sell.field.additionalDetails": "Weitere Details",
    "sell.field.optionalHint": "(optional - hilft Käufern, Ihre Anzeige zu finden)",
    "sell.field.select": "{label} wählen",
    "sell.validation.title": "Titel ist erforderlich",
    "sell.validation.category": "Kategorie ist erforderlich",
    "sell.validation.subcategory": "Unterkategorie ist erforderlich",
    "sell.validation.transactionType": "Transaktionsart ist erforderlich",
    "sell.validation.location": "Standort ist erforderlich",
    "sell.validation.price": "Preis ist erforderlich",
    "sell.review.title": "Anzeige prüfen",
    "sell.review.subtitle": "Stellen Sie sicher, dass alles stimmt",
    "sell.review.morePhotos": "+{n} Fotos",
    "sell.review.noPhotos": "Keine Fotos hinzugefügt",
    "sell.review.untitled": "Ohne Titel",
    "sell.review.free": "Kostenlos",
    "sell.review.negotiable": "Verhandelbar",
    "sell.review.noLocation": "Kein Standort",
    "sell.review.category": "Kategorie:",
    "sell.review.type": "Art:",
    "sell.review.condition": "Zustand:",
    "sell.review.yes": "Ja",
    "sell.review.no": "Nein",
    "sell.review.shipping": "Versand möglich",
    "sell.review.forRent": "Zu vermieten",
    "sell.review.forSale": "Zu verkaufen",
    "sell.error.publish": "Entwurf konnte nicht veröffentlicht werden",
    "sell.error.link": "Link konnte nicht gesendet werden",
    "sell.error.create": "Anzeige konnte nicht erstellt werden",
  },
  lb: {
    "sell.cancel": "Ofbriechen",
    "sell.mode.title": "Annonce opginn",
    "sell.mode.subtitle": "Wielt, wéi Dir Är Annonce erstelle wëllt",
    "sell.mode.createTitle": "Nei Annonce erstellen",
    "sell.mode.createDesc": "Fotoen eroplueden an Detailer bäifügen",
    "sell.mode.createBtn": "Ufänken",
    "sell.mode.importTitle": "Vun enger URL importéieren",
    "sell.mode.importDesc": "E Link vun enger anerer Websäit pechen",
    "sell.mode.importBtn": "Annonce importéieren",
    "sell.mode.aiNote": "Den Import benotzt KI, fir d'Detailer vun der Annonce ze extrahéieren an nei ze formuléieren",
    "sell.step.photos": "Fotoen",
    "sell.step.details": "Detailer",
    "sell.step.review": "Iwwerpréiwen",
    "sell.step.importUrl": "URL",
    "sell.import.title": "Annonce importéieren",
    "sell.import.urlLabel": "URL vun der Annonce",
    "sell.import.howItWorks": "Sou funktionéiert et:",
    "sell.import.how1": "D'KI extrahéiert Titel, Präis, Beschreiwung a Standuert",
    "sell.import.how2": "D'Beschreiwung gëtt professionell nei geschriwwen",
    "sell.import.how3": "Am nächste Schrëtt luet Dir Är eege Fotoen erop",
    "sell.import.how4": "Alles virum Publizéieren iwwerpréiwen an änneren",
    "sell.import.importing": "Import mat KI...",
    "sell.import.continue": "Importéieren & weider",
    "sell.import.manual": "Oder Annonce manuell erstellen →",
    "sell.import.enterUrl": "Gitt w.e.g. eng URL an",
    "sell.import.failed": "Import vun der Annonce feelgeschloen",
    "sell.import.success": "Donnéeë vun der Annonce importéiert!",
    "sell.photos.addTitle": "Fotoen bäifügen",
    "sell.photos.uploadTitle": "Fotoen eroplueden",
    "sell.photos.counter": "{n}/{max} Fotoen • Déi éischt Foto gëtt d'Titelbild",
    "sell.photos.max": "Maximal Unzuel u Fotoen erreecht",
    "sell.photos.click": "Klickt fir eropzelueden oder zitt Fotoen heihinner",
    "sell.photos.formats": "PNG, JPG bis zu 10 MB pro Fichier",
    "sell.photos.reorder": "Zéien fir ze sortéieren • Dat éischt Bild ass d'Titelbild",
    "sell.photos.reorderShort": "Zéien fir ze sortéieren • Éischt = Titelbild",
    "sell.photos.cover": "Titelbild",
    "sell.photos.uploaded": "{n} Foto(en) eropgelueden",
    "sell.photos.add": "Bäifügen",
    "sell.photos.aiTitle": "KI-Autofill",
    "sell.photos.aiDesc": "Fotoen analyséieren, fir Detailer virauszefëllen",
    "sell.photos.analyze": "Analyséieren",
    "sell.nav.back": "Zréck",
    "sell.nav.continue": "Weider",
    "sell.nav.review": "Annonce iwwerpréiwen",
    "sell.nav.backToPhotos": "Zréck bei d'Fotoen",
    "sell.nav.publish": "Annonce publizéieren",
    "sell.nav.publishing": "Gëtt publizéiert...",
    "sell.nav.cancelHome": "Ofbriechen an op d'Startsäit",
    "sell.nav.saveChanges": "Ännerunge späicheren",
    "sell.nav.editDetails": "Detailer änneren",
    "sell.details.title": "Detailer vun der Annonce",
    "sell.details.aiPrefilled": "D'KI huet e puer Felder virausgefëllt",
    "sell.details.editTitle": "Detailer änneren",
    "sell.details.editSubtitle": "Aktualiséiert d'Informatioune vun Ärer Annonce",
    "sell.field.title": "Titel",
    "sell.field.titlePh": "Wat verkaaft Dir?",
    "sell.field.category": "Kategorie",
    "sell.field.selectCategory": "Kategorie wielen",
    "sell.field.subcategory": "Ënnerkategorie",
    "sell.field.selectSubcategory": "Ënnerkategorie wielen",
    "sell.field.transactionType": "Transaktiounsaart",
    "sell.field.selectType": "Aart wielen",
    "sell.field.price": "Präis",
    "sell.field.priceType": "Präisaart",
    "sell.price.fixed": "Fixpräis",
    "sell.price.negotiable": "Verhandelbar",
    "sell.price.free": "Gratis",
    "sell.field.location": "Standuert",
    "sell.field.worldwide": "Dës Kategorie erlaabt Annoncen aus der ganzer Welt",
    "sell.field.locationPh": "Uertschaft sichen...",
    "sell.field.locationPhWorld": "Iergendeen Uert weltwäit sichen...",
    "sell.field.description": "Beschreiwung",
    "sell.field.descriptionPh": "Beschreift Ären Artikel am Detail...",
    "sell.field.condition": "Zoustand",
    "sell.field.selectCondition": "Zoustand wielen",
    "sell.field.shipping": "Versand méiglech",
    "sell.field.shippingDesc": "Kënnt Dir dësen Artikel verschécken?",
    "sell.field.propertyDetails": "Detailer vun der Immobilie",
    "sell.field.additionalDetails": "Weider Detailer",
    "sell.field.optionalHint": "(optional - hëlleft de Keefer, Är Annonce ze fannen)",
    "sell.field.select": "{label} wielen",
    "sell.validation.title": "Titel ass obligatoresch",
    "sell.validation.category": "Kategorie ass obligatoresch",
    "sell.validation.subcategory": "Ënnerkategorie ass obligatoresch",
    "sell.validation.transactionType": "Transaktiounsaart ass obligatoresch",
    "sell.validation.location": "Standuert ass obligatoresch",
    "sell.validation.price": "Präis ass obligatoresch",
    "sell.review.title": "Iwwerpréift Är Annonce",
    "sell.review.subtitle": "Kuckt, ob alles richteg ass",
    "sell.review.morePhotos": "+{n} Fotoen",
    "sell.review.noPhotos": "Keng Fotoen bäigefüügt",
    "sell.review.untitled": "Ouni Titel",
    "sell.review.free": "Gratis",
    "sell.review.negotiable": "Verhandelbar",
    "sell.review.noLocation": "Kee Standuert",
    "sell.review.category": "Kategorie:",
    "sell.review.type": "Aart:",
    "sell.review.condition": "Zoustand:",
    "sell.review.yes": "Jo",
    "sell.review.no": "Nee",
    "sell.review.shipping": "Versand méiglech",
    "sell.review.forRent": "Ze lounen",
    "sell.review.forSale": "Ze verkafen",
    "sell.error.publish": "Ären Entworf konnt net publizéiert ginn",
    "sell.error.link": "De Link konnt net geschéckt ginn",
    "sell.error.create": "D'Annonce konnt net erstallt ginn",
  },
};

export default sellFlow;
